import React from 'react';
import { Navigate, RouteObject } from 'react-router';

import { Auth0Guard } from '@anyx/common-auth';
import { Auth0Permissions, Restricted } from '@anyx/common-permission';
import { UserRoutePath } from '@anyx/common-routing';
import { FeatureFlag } from '@anyx/external-firebase';
import { NotFoundMessage, UnauthorizedMessage } from '@anyx/shared-ui';

const UserListPage = React.lazy(() =>
  import('./pages/list').then((module) => ({ default: module.UserListPage }))
);
const UserAddPage = React.lazy(() =>
  import('./pages/add').then((module) => ({ default: module.UserAddPage }))
);
const UserEditPage = React.lazy(() =>
  import('./pages/edit').then((module) => ({ default: module.UserEditPage }))
);
const UserNotificationsPage = React.lazy(() =>
  import('./pages/notifications').then((module) => ({ default: module.UserNotificationsPage }))
);
const UserTemplate = React.lazy(() =>
  import('./templates').then((module) => ({ default: module.UserTemplate }))
);
const UserNotificationsPageTemplate = React.lazy(() =>
  import('./templates').then((module) => ({
    default: module.UserNotificationsPageTemplate,
  }))
);

export const routes: RouteObject[] = [
  {
    path: 'user',
    element: (
      <Auth0Guard>
        <Restricted
          restrictions={[[Auth0Permissions.RESTRICTION_SEE_USERS]]}
          fallback={<UnauthorizedMessage />}
        >
          <UserTemplate />
        </Restricted>
      </Auth0Guard>
    ),
    children: [
      {
        path: 'list',
        element: <UserListPage />,
      },
      {
        path: 'add',
        element: (
          <Restricted
            permissions={[[Auth0Permissions.CAN_MANAGE_USERS]]}
            fallback={<UnauthorizedMessage />}
          >
            <UserAddPage />
          </Restricted>
        ),
      },
      {
        path: 'self',
        element: <UserEditPage isOnSelfPage />,
      },
      {
        path: ':masterDataUserId',
        element: <UserEditPage />,
      },
      {
        path: 'notifications',
        element: <UserNotificationsPageTemplate />,
        children: [
          {
            index: true,
            element: (
              <FeatureFlag name="mkp_notification_active">
                {(flag) => (flag?.value ? <UserNotificationsPage /> : <NotFoundMessage />)}
              </FeatureFlag>
            ),
          },
        ],
      },
      {
        index: true,
        element: <Navigate to={UserRoutePath().list().path} replace={true} />,
      },
    ],
  },
];
